import { render, staticRenderFns } from "./AccountWithdraws.vue?vue&type=template&id=7bd97614"
import script from "./AccountWithdraws.vue?vue&type=script&lang=js"
export * from "./AccountWithdraws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports